const Select = ({ value, label, name, options, onChange }) => (
  <div>
    {label && (
      <label
        htmlFor="input-field"
        className="text-supportiveMediumGray mb-2 block text-start text-sm font-medium"
      >
        {label}
      </label>
    )}
    <div className="relative">
      <select
        value={value}
        onChange={onChange}
        name={name}
        className="border-supportiveDarkGray text-supportiveBlack focus:outline-icon-color block h-9 w-full appearance-none border px-4 pr-8 text-base leading-tight focus:border-gray-500 focus:bg-white md:h-11"
      >
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute end-0 top-1/2 flex -translate-y-1/2 items-center px-2 text-gray-700">
        <svg
          className="size-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  </div>
);

export default Select;
